export interface BridgeMessage {
  action: string;
  payload: unknown;
}

export interface FromWebActions {
  openUrl: {
    url: string;
    target?: '_blank' | '_self';
  };
  goBack: null;
  reload: null;
}

export type FromWebActionName = keyof FromWebActions;

export interface FromNativeActions {
  error: {
    message: string;
    code?: string;
  };
}

export type FromNativeActionName = keyof FromNativeActions;

// Legacy types for backward compatibility
export type OpenUrl = FromWebActions['openUrl'];

// Base Bridge Types (legacy)
export interface BridgeCallback {
  onSuccess?: string;
  onError?: string;
}

export interface BridgeRequest<T = unknown> {
  name: string;
  data?: T;
}

// Environment Types
export enum EnvType {
  DEV = 'development',
  STAGING = 'staging',
  PROD = 'production',
}

// Feature Flags for coordinating behavior between releases
export interface FeatureFlags {
  callingEnabled: boolean;
}

// Utility types for strongly typed message sending
export type SendMessageToNative = <T extends FromWebActionName>(action: T, payload: FromWebActions[T]) => Promise<void>;

export type SendMessageToWeb = <T extends FromNativeActionName>(
  action: T,
  payload: FromNativeActions[T],
) => Promise<void>;

// Bridge Handler Types
export type BridgeHandler<T = unknown> = (data: T) => Promise<unknown> | unknown;

export interface BridgeHandlers {
  openUrl: BridgeHandler<OpenUrl>;
  goBack: BridgeHandler;
  reload: BridgeHandler;
}

// Message building utilities
export const buildBridgeMessage = <T extends FromWebActionName>(
  action: T,
  payload: FromWebActions[T],
): BridgeMessage => ({
  action,
  payload,
});

export const buildNativeMessage = <T extends FromNativeActionName>(
  action: T,
  payload: FromNativeActions[T],
): BridgeMessage => ({
  action,
  payload,
});
